import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	hero: {
		id: 'partner.hero',
		defaultMessage: 'Welcome to Calm',
		description: 'Title text on the partner landing page',
	},
	loading: {
		id: 'partner.loading',
		defaultMessage: 'Loading ...',
		description: 'Loading text on the partner landing page',
	},
});
